import type { Business } from "@/lib/types";
import {
  assertGeneratedPublicSeoTarget,
  assertGeneratedPublicSeoRoutes,
  bindGeneratedPublicSeoDataset,
  bindGeneratedPublicStorageUrl,
} from "@/lib/generatedPublicStorageUrls";

import {
  PUBLIC_BUSINESS_PROFILE_SEO,
  PUBLIC_BUSINESS_PROFILE_SEO_SHA256,
  PUBLIC_BUSINESS_PROFILE_SEO_TARGET,
} from "./publicBusinessProfileSeo.generated";

assertGeneratedPublicSeoTarget(PUBLIC_BUSINESS_PROFILE_SEO_TARGET);

const PUBLIC_BUSINESS_PROFILE_SEO_DATASET = bindGeneratedPublicSeoDataset(
  "businessProfileRoutes",
  PUBLIC_BUSINESS_PROFILE_SEO,
  PUBLIC_BUSINESS_PROFILE_SEO_SHA256
);

const PUBLIC_BUSINESS_PROFILE_SEO_BUSINESSES =
  (PUBLIC_BUSINESS_PROFILE_SEO_DATASET as unknown as Business[]).map((business) => ({
    ...business,
    logoUrl:
      bindGeneratedPublicStorageUrl(
        business.logoUrl,
        PUBLIC_BUSINESS_PROFILE_SEO_TARGET
      ) ?? undefined,
  }));

function cleanString(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

export function getGeneratedPublicBusinessProfileSlugs(): string[] {
  return PUBLIC_BUSINESS_PROFILE_SEO_BUSINESSES.map((business) =>
    cleanString(business.slug)
  )
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));
}

export function getGeneratedPublicBusinessProfile(
  slug?: string | null
): Business | null {
  const cleanSlug = cleanString(slug);
  if (!cleanSlug) return null;

  return (
    PUBLIC_BUSINESS_PROFILE_SEO_BUSINESSES.find(
      (business) => cleanString(business.slug) === cleanSlug
    ) ?? null
  );
}

assertGeneratedPublicSeoRoutes(
  "businessProfileRoutes",
  getGeneratedPublicBusinessProfileSlugs().map(
    (slug) => `/p/${encodeURIComponent(slug)}`
  ),
  PUBLIC_BUSINESS_PROFILE_SEO_TARGET
);
